import React from 'react'
import {
  Info,
  Loader2,
  CircleX,
  CircleAlert,
} from "lucide-react"
import { toast, Toaster as Sonner, type ToasterProps } from "sonner"
import { WistorIcon } from '@/icons/wistor'
import { Icon } from "@/components/widgets/Icon"

export const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      closeButton
      toastOptions={{
        classNames: {
          toast: "group text-[13px] font-exo",
          error: "!bg-red-200 !text-red-800",
          closeButton: "opacity-0 group-hover:opacity-100 focus-visible:opacity-100",
        }
      }}
      icons={{
        success: <Icon icon="circle-check" className="size-4 text-green-500" />,
        info: <WistorIcon className="size-5" />,
        warning: <Icon icon="triangle-exclamation" className="size-4 text-yellow-500" />,
        error: <CircleX className="size-4 text-red-800" />,
        loading: <Loader2 className="size-4 animate-spin" />,
      }}
      style={{
        "--normal-text": "#333333"
      } as React.CSSProperties}
      {...props}
    />
  )
}

// @ts-ignore
window.toast = toast
